(function () {
  function updateThumbnailAlignment() {
    document.querySelectorAll('.thumbnail-list').forEach((list) => {
      const visibleItems = Array.from(list.querySelectorAll('.thumbnail-list__item')).filter(
        (item) => item.getClientRects().length > 0
      );
      if (!visibleItems.length) return;

      const gap = parseFloat(window.getComputedStyle(list).columnGap) || 0;
      const itemsWidth = visibleItems.reduce((total, item) => total + item.getBoundingClientRect().width, 0);
      const contentWidth = itemsWidth + gap * Math.max(visibleItems.length - 1, 0);
      list.classList.toggle('thumbnail-list--centered', contentWidth <= list.clientWidth + 1);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateThumbnailAlignment);
  } else {
    updateThumbnailAlignment();
  }

  window.addEventListener('resize', updateThumbnailAlignment);
  document.addEventListener('shopify:section:load', updateThumbnailAlignment);

  const observer = new MutationObserver(updateThumbnailAlignment);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden'],
    childList: true,
    subtree: true,
  });
})();
